import React from 'react';
import { BotMessageSquare } from 'lucide-react';

interface SearchingLoaderProps {
  message?: string;
}

export const SearchingLoader: React.FC<SearchingLoaderProps> = () => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'flex-start',
        padding: '6px 12px',
        marginBottom: '8px'
      }}
    >
      {/* Bot Avatar - Consistent with Trigger and Header */}
      <div
        style={{
          width: '36px',
          height: '36px',
          backgroundColor: '#ffffff',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
          marginBottom: '4px',
          border: '2px solid #D9F0FF'
        }}
      >
        <BotMessageSquare size={20} color="#0f3340" strokeWidth={2} />
      </div>

      {/* Clean Professional Loader */}
      <div
        style={{
          marginLeft: '8px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start'
        }}
      >
        {/* White Message Bubble with 3 Dot Animation */}
        <div
          style={{
            padding: '14px 18px',
            borderRadius: '16px 16px 16px 4px',
            backgroundColor: '#ffffff',
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
            border: '1px solid #C1E4FB',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          {/* Elegant Pulsing Dots - Light Blue Shades */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
            <div
              style={{
                width: '8px',
                height: '8px',
                borderRadius: '50%',
                backgroundColor: '#a8ddef',
                animation: 'pulse 1.4s ease-in-out infinite'
              }}
            />
            <div
              style={{
                width: '8px',
                height: '8px',
                borderRadius: '50%',
                backgroundColor: '#83cbe6',
                animation: 'pulse 1.4s ease-in-out infinite',
                animationDelay: '0.2s'
              }}
            />
            <div
              style={{
                width: '8px',
                height: '8px',
                borderRadius: '50%',
                backgroundColor: '#5eb8db',
                animation: 'pulse 1.4s ease-in-out infinite',
                animationDelay: '0.4s'
              }}
            />
          </div>
        </div>
      </div>

      {/* Animations */}
      <style>{`
        @keyframes pulse {
          0%, 100% {
            transform: scale(1);
            opacity: 0.5;
          }
          50% {
            transform: scale(1.3);
            opacity: 1;
          }
        }
      `}</style>
    </div>
  );
};

export default SearchingLoader;
